export const EXPLAINER_AUTOPLAY_DELAY_MS = 5000;
